module.exports = __webpack_public_path__ + "img/Img10b_215588_CcFb-1-335.297a9383.jpg";